import React from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { toPersianNum } from "../../utils/persianNumbers";
import { cancelTradeRequest } from "../../services/trade";

const stepBuy = {
  0: "درخواست خرید",
  1: "در صف خرید ",
  2: "خریداری شد",
  3: "لغو شد",
};

const stepSell = {
  0: "درخواست فروش",
  1: "در صف فروش ",
  2: "فروخته شد",
  3: "لغو شد",
};

const stepWid = {
  0: "درخواست برداشت",
  1: "تایید برداشت",
  2: "واریز به حساب",
  3: "لغو شد",
};

const stepGold = {
  0: "درخواست تحویل",
  1: "کسر از صندوق",
  2: "تحویل",
  3: "لغو شد",
};

const StepRequest = ({ reqs, typeList }) => {
  const navigate = useNavigate();
  function RejectReq(id) {
    cancelTradeRequest(id)
      .then((res) => {
        if (res.status == 200) {
          if (res.data) {
            toast.success("درخواست شما با موفقیت لغو شد");
          }
        } else {
          toast.error(res.data.detail);
        }
      })
      .catch((error) => {});
  }

  return (
    <>
      {typeList === "buy" || typeList === "sell"
        ? !reqs ||
          !Array.isArray(reqs) ||
          (reqs.length === 0 && (
            <div className="no-history-item">
              <img src={"/images/account-no-history.png"} alt={""} />
              <div className="no-history-item-title">
                هنوز معامله نکرده‌اید؟
                <span>وقت طلاست!</span>
              </div>
              <div className="no-history-item-subtitle">
                همین حالا در طلایی‌شو بخرید، بفروشید و سود کنید.
              </div>
              <div className="trade-on-no-histoy">
                <button
                  className="form-input-button-custom"
                  onClick={() => navigate("/trade-market")}
                >
                  با بودجه کم معامله کنید
                </button>
              </div>
            </div>
          ))
        : typeList !== "pgold" && <></>}

      {reqs.length > 0 &&
        reqs.map((li) => (
          <div className="allstepCard" key={li.id}>
            <div className="d-flex plr-16">
              <div className="col-6 text-end">
                {typeList !== "wid" ? (
                  <>
                    {new Intl.NumberFormat("fa").format(
                      Math.abs(li["gold_amount"])
                    )}
                    {" گرم"} {toPersianNum(li["commodity"]["name"])}
                  </>
                ) : (
                  <>
                    {new Intl.NumberFormat("fa").format(
                      Math.abs(li["cash_amount"])
                    )}
                    {" تومان "}
                  </>
                )}
              </div>
            </div>

            <div className="MainContainer2020">
              <div className="StepContainer2020">
                <div className="progress-bar-items">
                  {[0, 1, 2].map((inp, index) => (
                    <div className="StepWrapper2020" key={`unique-${index}`}>
                      {inp !== 2 && (
                        <div
                          className={
                            li["status"] > inp
                              ? `lines-to-next active-line-to-next`
                              : `lines-to-next`
                          }
                          style={{
                            backgroundColor:
                              li["status"] > inp &&
                              li["commodity"] &&
                              li["commodity"]["color"]
                                ? li["commodity"]["color"]
                                : "",
                          }}
                        />
                      )}
                      <div className="StepStyle2020">
                        <div
                          className={`StepCount2020 ${
                            li["status"] >= inp ? "StepStyle2020-active" : ""
                          }`}
                          style={{
                            backgroundColor:
                              li["status"] >= inp &&
                              li["commodity"] &&
                              li["commodity"]["color"]
                                ? li["commodity"]["color"]
                                : "",
                          }}
                        >
                          {inp + 1}
                        </div>
                      </div>
                      <div className="StepsLabelContainer2020">
                        <div
                          className={`StepLabel2020  ${
                            li["status"] < inp ? "StepLabel2020-noactive" : ""
                          } `}
                        >
                          {typeList == "buy" &&
                            stepBuy[li["status"] == 3 && inp == 2 ? 3 : inp]}
                          {typeList == "sell" &&
                            stepSell[li["status"] == 3 && inp == 2 ? 3 : inp]}
                          {typeList == "wid" &&
                            stepWid[li["status"] == 3 && inp == 2 ? 3 : inp]}
                          {typeList == "pgold" &&
                            stepGold[li["status"] == 3 && inp == 2 ? 3 : inp]}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                <div className="side-progress-bar">
                  <div className="created-at-requests">
                    {toPersianNum(li["created_at"].split("T")[0])}
                  </div>
                  <div className="text-start">
                    {li["status"] !== 0 && li["status"] !== 1 ? (
                      <button
                        id={li["id"]}
                        className="btn-reject-request"
                        onClick={() => RejectReq(li["id"])}
                        disabled={true}
                      >
                        لغو
                      </button>
                    ) : (
                      <button
                        id={li["id"]}
                        className="btn-reject-request"
                        onClick={() => RejectReq(li["id"])}
                      >
                        لغو
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        ))}
    </>
  );
};

export default StepRequest;
